export const child = {
  id: 0,
  first_name: '',
  first_name_genitive: '',
  first_name_accusative: '',
  child: {
    id: 0
  },
  gender: {
    id: 0,
    value: '',
    display_value: ''
  },
  paid_amount: null,
  open_fundraising: true,
  province: {
    id: 0,
    name: ''
  },
  created_at: '',
  birthyear: '',
  avatar_id: 0,
  guardian_consent_content_child_choice_path: {
    futureSelf: '',
    threeWordsDescription: '',
    reasonsForHappiness: '',
    superpower: '',
    worldChange: '',
    applicationReason: '',
    dream: ''
  }
}
